export const checkoutUrl = 'https://wompi.com/es/co';

export const productImage =
  'https://cdn.magicpatterns.com/uploads/4q6aFNQehMvKbkMWsXq8t7/Modelo_Png_Sin_fondo_.png';

export const heroBadges = [
  { icon: 'file', label: '100% PDF' },
  { icon: 'zap', label: 'Acceso en 5 min' },
  { icon: 'flag', label: 'Protocolo Colombiano' },
  { icon: 'utensils', label: '7 → 30 Días' },
];

export const trustRow = [
  { icon: 'shield', label: 'Garantía 7 días' },
  { icon: 'lock', label: 'Pago seguro' },
  { icon: 'card', label: 'Wompi' },
];

export const heroStats = [
  { value: '+3.000', label: 'personas curadas' },
  { value: '5', label: 'Tomos listos' },
  { value: '5', label: 'Bonos incluidos' },
  { value: '4.9/5', label: 'calificación' },
];

export const heroTestimonials = [
  {
    initials: 'CR',
    quote:
      'El Día 7 ya no tenía hinchazón. Ahora en el Día 30 como en restaurantes sin miedo. Mi vida cambió.',
    author: 'Carolina R.',
    meta: 'Bogotá',
  },
  {
    initials: 'JM',
    quote:
      'Pensé que era alergia. Era solo comer inteligente. Los bonos me salvaron la semana.',
    author: 'Juan M.',
    meta: 'Medellín · Trabajador',
  },
  {
    initials: 'SP',
    quote:
      'Dejé de vivir en la farmacia. Ahora es comida real, digestión tranquila, vida normal.',
    author: 'Sandra P.',
    meta: 'Cali',
  },
];

export const painPoints = [
  'Desayunos que inflaman sin saber por qué',
  'Almuerzos donde no sabes qué pedir para no sufrir después',
  'Cenas donde el abdomen explota a los 30 minutos',
  'La microbiota sin estructura — alimentos al azar que te dañan',
  'Restaurantes prohibidos por miedo a la urgencia',
  'Fin de semana agotado — lunes vuelves al mismo ciclo',
];

export const tomos = [
  {
    number: 1,
    days: 'Días 1-2',
    title: 'Reset Digestivo',
    description:
      'Descanso intestinal, caldo de hueso, papaya, jengibre, respiración vagal.',
    color: '#2E7D32',
  },
  {
    number: 2,
    days: 'Días 3-4',
    title: 'Consolidación Enzimática',
    description:
      'Reintroducción segura, microbiota en reconstrucción, protocolo de monitoreo.',
    color: '#1E6FB8',
  },
  {
    number: 3,
    days: 'Días 5-6',
    title: 'Restauración Completa',
    description: 'Fase de potencia, alimentos más variados, test de tolerancia.',
    color: '#9A6B00',
  },
  {
    number: 4,
    days: 'Día 7',
    title: 'Estabilización y Permanencia',
    description:
      '7 hábitos diarios para mantener, protocolo de celebración, Plan B si reaparece.',
    color: '#C8551A',
  },
  {
    number: 5,
    days: 'Días 8-14',
    title: 'Reintroducción y Vida Normal',
    description:
      'Expansión alimentaria, tabla personal de tolerancia, restaurantes y viajes.',
    color: '#C2185B',
  },
];

export const tomoIncludes = [
  'Menú diario exacto (desayuno, almuerzo, cena)',
  'Recetas con ingredientes accesibles',
  'Tabla de síntomas y registro diario',
  'Lista de compra específica por día',
  'Errores comunes y cómo evitarlos',
  'Checklist de implementación',
  'Respuestas a preguntas frecuentes',
  '100% alineado a la microbiota intestinal',
];

export const bonos = [
  {
    number: '01',
    title: 'Diario Digestivo Inteligente (14 días)',
    description: 'Identifica tus alimentos gatillo en minutos.',
    value: '$22.990',
  },
  {
    number: '02',
    title: 'Lista de Mercado Colombia',
    description: 'Qué comprar en Éxito, D1, Ara o la plaza sin fallar.',
    value: '$22.990',
  },
  {
    number: '03',
    title: 'Kit de Cocina Digestiva Express',
    description: 'Cocina en 90 min para toda la semana (Batch Cooking).',
    value: '$22.990',
  },
  {
    number: '04',
    title: 'Guía Comer Fuera sin Miedo',
    description: 'Restaurantes, fiestas y viajes sin inflamación.',
    value: '$22.990',
  },
  {
    number: '05',
    title: 'SOS Estrés Digestivo en 5 Minutos',
    description: 'Rutinas para calmar el eje cerebro-intestino.',
    value: '$22.990',
  },
];

export const bonosTotal = '$114.950';

export const comparisonRows = [
  {
    situation: 'Día 8: ¿Qué cocino ese día?',
    without: 'Improvisas y regresas a síntomas',
    with: 'Calendario exacto. 30 días listos.',
  },
  {
    situation: '¿Cómo reintroduzco alimentos?',
    without: 'Pruebas al azar y fallas',
    with: 'Sistema de 3 fases estructurado.',
  },
  {
    situation: '¿Puedo comer en restaurantes?',
    without: 'Miedo a fallar',
    with: 'Protocolo probado. Tranquilo.',
  },
  {
    situation: 'Domingo: prep de comida',
    without: '4 horas buscando recetas',
    with: 'Batch cooking plan. 90 min.',
  },
  {
    situation: '¿Es permanente mi curación?',
    without: 'Efecto rebote garantizado',
    with: 'Protocolo de mantenimiento eterno.',
  },
];

export const planIncludes = [
  'Calendario de 30 días (Día por día)',
  '60+ recetas colombianas digestivas',
  '3 fases de consolidación estructuradas',
  'Batch cooking para toda la semana',
  'Protocolo de vida social y restaurantes',
  'Tracker de síntomas integrado',
  'Sistema de mantenimiento permanente',
];

export const moreTestimonials = [
  {
    initials: 'MV',
    author: 'Mónica V.',
    city: 'Bogotá',
    tag: 'MegaPack Completo',
    quote:
      'El Tomo 3 fue revelador. Descubrí que el ajo me inflamaba. Ahora como sin miedo.',
  },
  {
    initials: 'DL',
    author: 'Diego L.',
    city: 'Barranquilla',
    tag: 'Trabajador de Oficina',
    quote:
      'El Batch Cooking me salvó. Llevo tupperware al trabajo y como mejor que antes.',
  },
  {
    initials: 'AC',
    author: 'Adriana C.',
    city: 'Cali',
    tag: 'MegaPack + Plan Maestro',
    quote:
      "Día 30 y como en restaurantes. Mi familia me pregunta qué hice. Digo: 'Comí inteligente.'",
  },
  {
    initials: 'RF',
    author: 'Roberto F.',
    city: 'Medellín',
    tag: 'Ejecutivo',
    quote:
      'No creía que iba a durar. Pero el protocolo es tan claro que se vuelve automático.',
  },
];

export const faqs = [
  {
    question: '¿Sirve para todos los tipos de colon irritable?',
    answer:
      'Sí. El protocolo está diseñado para hinchazón, gases, dolor y urgencia. Los bonos te ayudan a identificar TU patrón específico.',
  },
  {
    question: '¿Cómo recibo el material?',
    answer:
      'En 5 minutos después del pago, recibirás un correo con links de descarga. 100% PDF, accesible desde tu celular, tablet o computador.',
  },
  {
    question: '¿Necesito comprar suplementos caros?',
    answer:
      'No. El protocolo es comida real que encuentras en cualquier mercado colombiano. Nada de importaciones raras.',
  },
  {
    question: '¿Tiene garantía real?',
    answer:
      'Sí. 7 días, devolución completa, sin preguntas. Si no funciona, te devolvemos el dinero. Punto.',
  },
];

export const costOfInaction = [
  { title: 'Farmacia constante', detail: '$5.000-20.000/mes' },
  { title: 'Abdomen inflamado', detail: 'Vida social limitada' },
  { title: 'Restaurantes prohibidos', detail: 'Miedo constante' },
  { title: 'Confusión alimentaria', detail: 'Errores diarios' },
  { title: 'Sueño afectado', detail: 'Mala digestión nocturna' },
  { title: 'Energía baja', detail: 'Productividad perdida' },
  { title: 'Mismo ciclo', detail: 'El próximo año igual' },
];

export const pricing = {
  original: '$155.000',
  current: '$53.990',
  currency: 'COP',
  increase: 'a $155.000 COP',
  claimedPercent: 78,
};

export const paymentMethods = 'Wompi | Transferencia | Tarjeta de crédito';

export const contact = {
  email: 'soportiendapdf@gmail.com',
  instagram: '@habil_online',
};
